import config from "../../config";
import {
  PARTICIPANT,
  COORDINATOR,
  REPRESENTATIVE,
  TEAM_ADMIN,
} from "../../constants";
import { FundraiserForAccount } from "../../Interfaces/AccountUsers";
import { useNavigate } from "react-router-dom";
import { endDateFilter } from "../../pages/RefactoredDashboards/GeneralDashboard";
import UploadAndViewAccountProfilePhoto from "../Forms/AccountProfilePhotos/UploadAndViewAccountProfilePhoto/UploadAndViewProfilePhoto";

export const getShareButtonText = (
  fundraiser: FundraiserForAccount,
  isMobile: boolean,
) => {
  const verbChoice = isMobile ? "Copy" : "Share";

  return fundraiser.fundraiser_type === PARTICIPANT
    ? `${verbChoice} Store Link`
    : `${verbChoice} Invite Link`;
};

export const calculateProgressPercentage = (raised: number, goal: number) => {
  if (!goal) return 0;
  return Math.min(((raised ?? 0) / goal) * 100, 100);
};

export const useHandleViewFundraiser = () => {
  const navigate = useNavigate();

  const PATHS: Record<string, (f: FundraiserForAccount) => string> = {
    [PARTICIPANT]: (f) => `/dashboard/participant/${f.code}/`,
    [REPRESENTATIVE]: () => `/dashboard/fundraising-rep/`,
    [COORDINATOR]: (f) => `/dashboard/coord/${f.fundraiser_id}`,
    [TEAM_ADMIN]: (f) => `/dashboard/teamAdmin/${f.fundraiser_id}/`,
  };

  return (fundraiser: FundraiserForAccount) => {
    const getPath = PATHS[fundraiser.fundraiser_type];

    if (getPath) {
      navigate(getPath(fundraiser));
    } else {
      alert(
        `Unidentified fundraiser type. Please alert support at ${config.SUPPORT_EMAIL}`,
      );
    }
  };
};

export const useNavigateToJoinFundraiser = () => {
  const navigate = useNavigate();
  return () => navigate("/register-or-shop");
};

export const calculateActiveFundraisers = (
  fundraisers: FundraiserForAccount[],
): number => {
  return fundraisers.filter((f) => f.is_active).length;
};

interface FilterFundraisersByEndDateProps {
  filterView: string | undefined;
  setFilterView: (option: string | undefined) => void;
}

export const FilterFundraisersByEndDate: React.FC<
  FilterFundraisersByEndDateProps
> = ({ filterView, setFilterView }) => {
  return (
    <div
      className="filter-fundraisers-by-end-date-container"
      style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
    >
      <label style={{ margin: 0, whiteSpace: "nowrap" }}>
        Select Fundraiser Filtering:
      </label>
      <select
        value={filterView || ""}
        onChange={(e) => setFilterView(e.target.value || undefined)}
      >
        {Object.entries(endDateFilter).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export const displayFundraiserProfileUpload: React.FC<{
  fundraiser: FundraiserForAccount;
}> = ({ fundraiser }) => {
  return fundraiser && fundraiser.fundraiser_type === PARTICIPANT ? (
    <UploadAndViewAccountProfilePhoto
      selectedAccountProfileIdInt={fundraiser.account_profile_id}
      account_profile_image_url={fundraiser.profile_picture}
    />
  ) : null;
};
